import React, { Component } from 'react';
import { notification } from 'antd';
import { Mutation } from '@apollo/react-components';
import { gql } from '@apollo/client';
import routes from '@achievable-me/tundra-wizard/routes';
import Bounce from '$components/Bounce';
import AuthLayout from '$components/layout/AuthLayout';
import Seo from '$components/Seo';
import CURRENT_USER from '$queries/currentUser';
import storage from '$lib/storage';
import { trackSignUp } from '$lib/tracking';
import SignUpForm from './SignUpForm';

const SIGN_UP = gql`
  mutation SignUp($input: SignUpInput!) {
    signUp(input: $input) {
      uuid
      email
      accessToken
    }
  }
`;

class SignUp extends Component {
  render() {
    const { currentUser } = this.props;

    if (currentUser) {
      return <Bounce currentUser={currentUser} />;
    }

    return (
      <AuthLayout>
        <Seo
          title="Sign up"
          canonical={routes.auth.signUp}
          description="Sign up for an Achievable account to track your progress towards passing your exam."
        />
        <Mutation
          mutation={SIGN_UP}
          refetchQueries={[{ query: CURRENT_USER }]}
          update={(_cache, { data, error }) => {
            const { signUp } = data;
            if (!signUp) {
              notification.error({
                message: 'Error',
                description: error,
              });
              return;
            }

            const { uuid, email, accessToken } = signUp;
            storage.setAuth({ email, accessToken });

            trackSignUp({ userUuid: uuid, sourcePage: 'auth' });
          }}
        >
          {(signUp, { loading }) => <SignUpForm signUp={signUp} loading={loading} />}
        </Mutation>
      </AuthLayout>
    );
  }
}

export default SignUp;
